/** @jsx jsx */

import React, { Fragment as _, useContext, useEffect, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import { interactionContext } from './interactionContext';
import { unlockInteraction } from 'services/unlockInteraction';
import { findByKeyVal_V2 } from 'services/findByKeyVal';
import { ImageContext } from 'components/lib/Image';
import getStore from 'services/getStore';
import landingPageCake_1 from 'assets/landingPageCake_1.png';
import landingPageCake_2 from 'assets/landingPageCake_2.png';
import landingPageCake_3 from 'assets/landingPageCake_3.png';
import landingPageCake_4 from 'assets/landingPageCake_4.png';
import landingPageCake_5 from 'assets/landingPageCake_5.png';
import landingPageCake_6 from 'assets/landingPageCake_6.png';
import { useSelector } from 'react-redux';
import { State } from 'store/store';

const { lGrey2 } = colors;

const cakes = [
  landingPageCake_1,
  landingPageCake_2,
  landingPageCake_3,
  landingPageCake_4,
  landingPageCake_5,
  landingPageCake_6,
];

const store = getStore();

const ClickAndReveals = ({ children, ...props }) => {
  const context = useContext(interactionContext);
  const { id: contextId } = context;

  const itemsSeen = useRef(
    unlockInteraction(context.id, (children as any).length)
  );

  const { sId, isLandingPage } = context.props;

  context.numPanels = children.length;

  const landingPageSeenState = useSelector((state: State) => {
    return state?.landingPagesSeenState?.[sId || context.id] || [];
  });

  // console.log({ landingPageSeenState });

  context.updateClickAndRevealSeen = id => {
    store.dispatch({
      type: 'UPDATE_LANDING_PAGE_SEEN_STATE',
      data: {
        parentId: sId || contextId,
        childIndex: children.findIndex(child => {
          return child?.props?.id === id;
        }),
      },
    });
  };

  useEffect(() => {
    // console.log(landingPageSeenState.length, context.numPanels);
    if (landingPageSeenState.length == context.numPanels) {
      unlockInteraction(contextId);
    }
  }, [landingPageSeenState.length]);

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        width: 100%;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          height: 100%;
        `}
      >
        {children.map((child: any, index: number) => {
          const element = React.cloneElement(child, {
            key: child.props.id,
            parentId: props.id,
            seen: landingPageSeenState.includes(index),
          });
          const reIndex = index % 6;

          return isLandingPage ? (
            <ImageContext.Provider
              key={`${child.props.id}-cake`}
              value={{
                placeholder: cakes[reIndex],
              }}
            >
              {element}
            </ImageContext.Provider>
          ) : (
            element
          );
        })}
      </div>
    </div>
  );
};

export default ClickAndReveals;
